// All function will be in HOF form to enable the middleware to do its job
// Get All Movies
import { Movies } from "./Types";
import axios from "axios";
// fisrt Action to Get All Movies
// this function will be dispatched by components
export const getAllMovies = () => {
  // Dispatch param sends the action object to the reducer
  // This Returned function won't dispatch till The HOF function is
  // dispatched by the another component
  return async (dispatch) => {
    let res = await axios.get(
      "https://api.themoviedb.org/3/movie/popular?api_key=f322ddbfea3ab9b5fac98fda3edb0056&language=ar"
    );
    dispatch({
      type: Movies,
      data: res.data.results,
      pages: 500,
    });
  };
};

//second Action to get searched movies
export const searchingFunction = (word) => {
  return async (dispatch) => {
    if (word === "") {
      dispatch(getAllMovies());
    } else {
      const res = await axios.get(
        `https://api.themoviedb.org/3/search/movie?api_key=f322ddbfea3ab9b5fac98fda3edb0056&query=${word}&language=ar`
      );
      dispatch({
        type: Movies,
        data: res.data.results,
        pages: res.data.total_pages,
      });
    }
  };
};

export const paginateFunction = (page) => {
  return async (dispatch) => {
    const res = await axios.get(
      `https://api.themoviedb.org/3/movie/popular?api_key=f322ddbfea3ab9b5fac98fda3edb0056&language=ar&page=${page}`
    );
    dispatch({
      type: Movies,
      data: res.data.results,
      pages: 500,
    });
  };
};

// HOF ==> Higher Order Function ==> these function which accept a function or return it.